<template>
    <div class="mt-20">
        <el-button
            @click="create"
            type="primary"
            v-if="can(Permissions.CREATE_THEME)"
            ><i class="mdi mdi-upload-multiple" /> Upload Themes
        </el-button>
        <el-table :data="items.data">
            <el-table-column prop="year" label="Year/Month">
                <template v-slot="scope">
                    {{ scope.row.formatted_month }}
                </template>
            </el-table-column>
            <el-table-column label="Name" prop="name" />
            <el-table-column prop="preview" label="Preview">
                <template v-slot="{ row }">
                    <img
                        :src="
                            data_get(row, 'categories.data.0.file.preview.url')
                        "
                        alt="Preview"
                        v-if="data_get(row, 'categories.data.0.file.preview')"
                        width="100"
                    />
                    <img
                        v-else
                        :src="
                            data_get(row, 'categories.data.1.file.preview.url')
                        "
                        alt="Preview"
                        width="100"
                    />
                </template>
            </el-table-column>
            <el-table-column
                prop="actions"
                v-if="
                    can(Permissions.EDIT_THEME) || can(Permissions.DELETE_THEME)
                "
                width="250px"
            >
                <template v-slot="scope">
                    <el-button-group size="small">
                        <el-button
                            @click="editItem(scope.row)"
                            icon="mdi mdi-pencil"
                            v-if="can(Permissions.EDIT_THEME)"
                            >Edit
                        </el-button>
                        <el-button
                            type="danger"
                            icon="mdi mdi-delete"
                            @click="deleteItem(scope.row)"
                            v-if="can(Permissions.DELETE_THEME)"
                            :loading="isDeletingItem(scope.row)"
                            >Delete
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :disabled="loading"
            class="mt-10"
            :pagination="items.meta.pagination"
            v-if="items.meta.pagination"
            @current-change="onCurrentChange"
        />
        <el-dialog
            :title="'Upload Themes'"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="1200px"
        >
            <el-form @submit.prevent="submit()">
                <el-form-item
                    style="max-width: 400px"
                    label="Year/Month"
                    label-width="150px"
                    :class="form.state('month')"
                >
                    <el-date-picker
                        style="width: 100%"
                        v-model="form.year_month"
                        @change="onChangeMonth"
                        type="month"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-card
                    v-for="(theme, themeIndex) in form.themes"
                    v-bind:key="themeIndex"
                    class="mb-10"
                >
                    <el-button
                        v-if="form.themes.length > 1"
                        @click="deleteTheme(themeIndex)"
                        icon="mdi mdi-close"
                        size="mini"
                        type="text"
                        class="close"
                    />
                    <div class="flex-box left" style="width: 100%">
                        <div style="width: 50%" class="mr-10">
                            <el-form-item label="Name">
                                <el-input
                                    v-model="theme.name"
                                    :class="
                                        form.state(`themes.${themeIndex}.name`)
                                    "
                                />
                                <form-feedback
                                    class="text-small"
                                    :form="form"
                                    :field="`themes.${themeIndex}.name`"
                                />
                            </el-form-item>
                        </div>
                        <div style="width: 50%" class="ml-10">
                            <el-form-item
                                :class="form.state('corporation_id')"
                                label="Calendar Visibility"
                            >
                                <el-select
                                    clearable
                                    filterable
                                    placeholder="Everyone"
                                    v-model="theme.corporation_id"
                                >
                                    <el-option :value="null" label="Everyone">
                                    </el-option>
                                    <el-option
                                        :key="item.id"
                                        :label="'Only ' + item.name"
                                        :value="item.id"
                                        v-for="item in corporations"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div>
                        <span class="label">Theme Files</span>
                        <el-button
                            v-if="form.themes[themeIndex].categories.length < 2"
                            @click="addCategory(themeIndex)"
                            round
                            icon="mdi mdi-plus"
                            size="mini"
                            type="primary"
                        />
                        <el-table :data="theme.categories">
                            <el-table-column label="Theme Category" prop="name">
                                <template v-slot="scope">
                                    <el-input
                                        v-if="scope.row.name != null"
                                        v-model="scope.row.name"
                                        :class="
                                            form.state(
                                                `themes.${themeIndex}.categories.${getCategoryIndex(
                                                    scope.row,
                                                    themeIndex
                                                )}.name`
                                            )
                                        "
                                        :label="scope.row.name | capitalize_all"
                                        :readonly="true"
                                    />

                                    <el-select
                                        v-else
                                        v-model="scope.row.name"
                                        placeholder="Select Category"
                                    >
                                        <el-option
                                            v-for="categoryName in ThemeCategories"
                                            :key="categoryName"
                                            :label="
                                                categoryName | capitalize_all
                                            "
                                            :value="categoryName"
                                        >
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="Theme File" prop="upload">
                                <template v-slot="scope">
                                    <el-form-item
                                        :class="
                                            form.state(
                                                `themes.${themeIndex}.categories.${getCategoryIndex(
                                                    scope.row,
                                                    themeIndex
                                                )}.upload`
                                            )
                                        "
                                    >
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            @change="
                                                (e) => {
                                                    onChangeFile(
                                                        scope.row,
                                                        e,
                                                        theme
                                                    );
                                                }
                                            "
                                        />
                                        <form-feedback
                                            class="text-small"
                                            :form="form"
                                            :field="`themes.${themeIndex}.categories.${getCategoryIndex(
                                                scope.row,
                                                themeIndex
                                            )}.upload`"
                                        />
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Title Color"
                                prop="title_color"
                            >
                                <template v-slot="scope">
                                    <el-color-picker
                                        :predefine="availableColors"
                                        v-model="scope.row.title_color"
                                    >
                                    </el-color-picker>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Title Outline Color"
                                prop="title_outline_color"
                            >
                                <template v-slot="scope">
                                    <el-color-picker
                                        :predefine="availableColors"
                                        v-model="scope.row.title_outline_color"
                                    >
                                    </el-color-picker>
                                </template>
                            </el-table-column>
                            <el-table-column label="">
                                <template v-slot="scope">
                                    <el-button
                                        @click="
                                            deleteCategory(
                                                themeIndex,
                                                getCategoryIndex(
                                                    scope.row,
                                                    themeIndex
                                                )
                                            )
                                        "
                                        icon="mdi mdi-close"
                                        round
                                        size="mini"
                                        type="danger"
                                        class="float-right"
                                    />
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
                <el-button
                    @click="addTheme()"
                    icon="mdi mdi-plus"
                    round
                    size="mini"
                    type="primary"
                    >Add Theme</el-button
                >
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" :disabled="form.busy"
                    >Cancel</el-button
                >
                <el-button
                    type="primary"
                    icon="mdi mdi-content-save"
                    @click="submit"
                    :loading="form.busy"
                    >Save
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :title="'Edit Theme'"
            :visible.sync="editDialogVisible"
            width="700px"
        >
            <el-form @submit.prevent="submit()">
                <div class="flex-box left" style="width: 100%">
                    <div style="width: 50%" class="mr-10">
                        <el-form-item
                            label="Name"
                            :class="editForm.state('name')"
                        >
                            <el-input v-model="editForm.name" />
                            <form-feedback :form="editForm" field="name" />
                        </el-form-item>
                    </div>
                    <div style="width: 50%" class="ml-10">
                        <el-form-item
                            :class="editForm.state('corporation_id')"
                            label="Calendar Visibility"
                        >
                            <el-select
                                clearable
                                filterable
                                placeholder="Everyone"
                                v-model="editForm.corporation_id"
                            >
                                <el-option :value="null" label="Everyone">
                                </el-option>
                                <el-option
                                    :key="item.id"
                                    :label="'Only ' + item.name"
                                    :value="item.id"
                                    v-for="item in corporations"
                                >
                                </el-option>
                            </el-select>
                            <form-feedback
                                :form="editForm"
                                field="corporation_id"
                            />
                        </el-form-item>
                    </div>
                </div>

                <el-card
                    v-for="(category, i) in editForm.categories.data"
                    v-bind:key="i"
                    class="mb-10"
                >
                    <div class="label">
                        {{ category.name | capitalize_all }}
                    </div>
                    <div class="flex-box">
                        <div style="width: 50%">
                            <el-form-item
                                label="File"
                                class="mb-5"
                                :class="editForm.state(`categories.${i}.file`)"
                            >
                                <input
                                    name="uploads[]"
                                    type="file"
                                    accept="application/pdf"
                                    @change="
                                        (e) => {
                                            onChangeFile(
                                                category,
                                                e,
                                                null,
                                                true
                                            );
                                        }
                                    "
                                />
                                <form-feedback
                                    :form="editForm"
                                    :field="`categories.${i}.file`"
                                />
                            </el-form-item>
                            <img
                                v-if="category.file.preview.url"
                                :src="category.file.preview.url"
                                width="200"
                            />
                        </div>
                        <div>
                            <div style="width: 100%; vertical-align: middle">
                                <el-form-item
                                    :class="
                                        editForm.state(
                                            `categories.${i}.title_color`
                                        )
                                    "
                                    class="mb-0 d-inline-block"
                                    label="Calendar Title Color"
                                >
                                    <custom-color-picker
                                        :predefine="availableColors"
                                        v-model="category.title_color"
                                    >
                                    </custom-color-picker>
                                    <form-feedback
                                        :form="editForm"
                                        field="`categories.${i}.title_color`"
                                    />
                                </el-form-item>
                                <el-form-item
                                    :class="
                                        editForm.state(
                                            `categories.${i}.title_outline_color`
                                        )
                                    "
                                    class="mb-0 d-inline-block"
                                    label="Calendar Title Outline Color"
                                >
                                    <custom-color-picker
                                        :predefine="availableColors"
                                        v-model="category.title_outline_color"
                                    >
                                    </custom-color-picker>
                                    <form-feedback
                                        :form="editForm"
                                        field="`categories.${i}.title_outline_color`"
                                    />
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    @click="editDialogVisible = false"
                    :disabled="editForm.busy"
                    >Cancel</el-button
                >
                <el-button
                    type="primary"
                    icon="mdi mdi-content-save"
                    @click="submit"
                    :loading="editForm.busy"
                    >Save Changes
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as ThemeCategories from "@/constants/theme-categories";
import unsaved_changes_mixin from "@/mixins/unsaved-changes";
import * as Actions from "@/store/constants/actions";
import auth from "@/mixins/auth";
import moment from "moment";
import _ from "lodash";
import Vue from "vue";

function addTheme() {
    return {
        name: "",
        corporation_id: null,
        categories: [
            {
                name: "with logo",
                title_color: "#000000",
                title_outline_color: null,
                file: null,
                file_src: null,
                preview_src: null,
                upload: null,
            },
            {
                name: "no logo",
                title_color: "#000000",
                title_outline_color: null,
                file: null,
                file_src: null,
                preview_src: null,
                upload: null,
            },
        ],
    };
}

function addCategoryFile(categoryName = null) {
    return {
        name: categoryName,
        title_color: "#000000",
        title_outline_color: null,
        file: null,
        file_src: null,
        preview_src: null,
        upload: null,
    };
}

/**
 * Vue component for displaying and managing monthly PDF themes.
 * @component MonthlyPdfThemes
 * @file /home/coop/work/corwin/corwin-app/resources/js/views/pages/themes/MonthlyPdfThemes.vue
 *
 * @returns {Object} The data object containing the component's properties and state.
 * @property {Array} ThemeCategories - An array of theme categories.
 * @property {boolean} dialogVisible - Flag indicating whether the dialog is visible.
 * @property {boolean} editDialogVisible - Flag indicating whether the edit dialog is visible.
 * @property {Object} form - The form object for creating new themes.
 * @property {Object} editForm - The form object for editing existing themes.
 * @property {string|null} logo_src - The source URL of the logo.
 * @property {Object|null} editingItem - The item being edited.
 * @property {boolean} loading - Flag indicating whether the component is in a loading state.
 * @property {Object} items - The data object containing the items and pagination metadata.
 * @property {Array} deletingItems - An array of items to be deleted.
 * @property {Object|null} oldData - The previous data state.
 */

export default {
    mixins: [unsaved_changes_mixin, auth],
    data() {
        return {
            ThemeCategories,
            dialogVisible: false,
            editDialogVisible: false,
            form: new window.Form({
                year_month: null,
                month: moment().month(),
                year: moment().year(),
                themes: [addTheme()],
            }),
            editForm: new window.Form({
                name: null,
                categories: [],
                corporation_id: null,
            }),
            logo_src: null,
            editingItem: null,
            loading: false,
            items: {
                data: [],
                meta: {
                    pagination: null,
                },
            },
            deletingItems: [],
            oldData: null,
        };
    },
    computed: {
        hasChanges() {
            if (
                !this.oldData ||
                (!this.dialogVisible && !this.editDialogVisible)
            ) {
                return false;
            }
            return this.oldData !== this.getCleanFormData();
        },
        availableColors() {
            return this.$store.state.config.settings.calendar.title_colors;
        },
        corporations() {
            return this.$store.state.corporations.data;
        },
    },
    created() {
        this.$store.dispatch(Actions.FETCH_CORPORATIONS);
    },
    mounted() {
        this.getItems();
        this.form.setVeeErrors(this.veeErrors);
    },
    methods: {
        initOldData() {
            this.oldData = this.getCleanFormData();
        },
        getCleanFormData() {
            let data = {};
            if (this.editingItem) {
                data = _.pick(this.editForm, [
                    "name",
                    "corporation_id",
                    "categories",
                ]);
            } else {
                data = _.pick(this.form, ["themes", "month", "year"]);
            }
            return JSON.stringify(data);
        },
        create() {
            this.editingItem = null;
            this.dialogVisible = true;
            this.form.clearFields();
            this.form.themes = [];
            Vue.nextTick(() => {
                let newTheme = addTheme();
                this.form.themes.push(newTheme);
                this.initOldData();
            });
        },
        getItems(page = 1) {
            this.loading = true;
            window.axios
                .get(`/web-api/theme?include=categories.file.preview`, {
                    params: {
                        page,
                    },
                })
                .then((response) => {
                    this.items.data = response.data.data;
                    this.items.meta.pagination = response.data.meta.pagination;
                })
                .finally(() => (this.loading = false));
        },
        onCurrentChange(e) {
            this.getItems(e);
        },
        addTheme() {
            this.form.themes.push(addTheme());
        },
        onChangeMonth(e) {
            this.form.year = e.getFullYear();
            this.form.month = e.getMonth() + 1;
        },
        onChangeFile(category, e, theme, is_edit = false) {
            //console.log("onChangeFile", [category, e, theme, is_edit]);
            if (is_edit) {
                let category_file = this.editForm.categories.data.find(
                    (item) => item === category
                );
                //console.log("category_file", category_file);
                category_file.upload = _.get(e, "target.files.0");
                //console.log("category_file.upload", category_file.upload);
            } else {
                let theme_file = this.form.themes.find(
                    (item) => item === theme
                );
                //console.log("theme_file", theme_file);
                let category_file = theme_file.categories.find(
                    (item) => item === category
                );
                //console.log("category_file", category_file);
                category_file.upload = _.get(e, "target.files.0");
                //console.log("category_file.upload", category_file.upload);
            }
        },
        getThemeIndex(theme) {
            return this.form.themes.indexOf(theme);
        },
        submit() {
            if (this.editingItem) {
                //console.log("submit", this.editForm);
                window.App.putData(
                    `/web-api/theme/${this.editingItem.id}?include=categories.file.preview`,
                    this.editForm
                ).then((response) => {
                    //console.log(response.data);
                    this.editDialogVisible = false;
                    this.$notify.success({
                        message: `Changes have been saved to theme.`,
                    });
                    _.extend(this.editingItem, response.data);
                });
            } else {
                //console.log("submit", this.form.themes);
                window.App.postData(
                    `/web-api/theme?include=categories.file.preview`,
                    this.form
                ).then((response) => {
                    //console.log(response.data);
                    this.dialogVisible = false;
                    this.$notify.success({
                        message: `New themes has been saved.`,
                    });
                    response.data.data.forEach((item) => {
                        this.items.data.splice(0, 0, item);
                    });
                });
            }
        },
        editItem(item) {
            this.editForm.clearFields();
            _.extend(
                this.editForm,
                _.pick(item, ["name", "corporation_id", "categories"])
            );
            this.editingItem = item;
            this.editDialogVisible = true;
            // _.forEach(this.editingItem.categories, (category) => {
            //     let file = category.file;
            //     this.editForm.files.push({
            //         category,
            //         file: null,
            //         file_src: null,
            //         preview_src: _.get(file, "preview.url"),
            //     });
            // });
            this.initOldData();
        },
        isDeletingItem(item) {
            return _.includes(this.deletingItems, item);
        },
        deleteItem(item) {
            this.$confirm("Confirm delete theme?", "Confirmation", {
                confirmButtonText: "Delete",
                confirmButtonClass: "el-button--danger",
                cancelButtonText: "Cancel",
                type: "warning",
            })
                .then(() => {
                    this.deletingItems.push(item);
                    window.axios
                        .delete(`/web-api/theme/${item.id}`)
                        .then(() => {
                            window.Utils.arrayDelete(this.items.data, item);
                            this.$notify.success({
                                message: `Theme ${item.name} has been deleted.`,
                            });
                        })
                        .catch(() => {
                            this.$notify.error({
                                message: `Cannot delete theme ${item.name}.`,
                            });
                        })
                        .finally(() => {
                            window.Utils.arrayDelete(this.deletingItems, item);
                        });
                })
                .catch(() => {});
        },
        addCategory(index) {
            if (this.form.themes[index].categories.length > 0) {
                let name = Object.values(this.ThemeCategories).find(
                    (item) => item != this.form.themes[index].categories[0].name
                );
                this.form.themes[index].categories.push(addCategoryFile(name));
            } else {
                this.form.themes[index].categories.push(addCategoryFile());
            }
        },
        deleteTheme(index) {
            this.form.themes.splice(index, 1);
        },
        deleteCategory(themeIndex, index) {
            this.form.themes[themeIndex].categories.splice(index, 1);
        },
        getCategoryIndex(category, themeIndex) {
            return this.form.themes[themeIndex].categories.indexOf(category);
        },
    },
};
</script>

<style scoped>
.w-half {
    width: 49%;
}
.flex-box {
    display: flex;
    padding: 10px;
}
.close {
    float: right;
    position: relative;
    margin-top: -15px;
    cursor: pointer;
    font-weight: bold;
}

.left {
    float: left;
}

.clear {
    clear: both;
}

.label {
    font-weight: bold;
}
</style>
